import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/utils/api';

export function useConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: async () => {
      const response = await api.get('/config');
      return response.data;
    }
  });
}

export function useConfigMutate() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (config) => {
      const response = await api.put('/config', config);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['config'] });
    }
  });
}

export function usePluginConfig() {
  return useQuery({
    queryKey: ['config', 'plugins'],
    queryFn: async () => {
      const response = await api.get('/config/plugins');
      return response.data;
    }
  });
}

export function usePluginConfigMutate() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (pluginConfig) => {
      const response = await api.put('/config/plugins', pluginConfig);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['config'] });
      queryClient.invalidateQueries({ queryKey: ['config', 'plugins'] });
    }
  });
}

export function usePluginStatus() {
  return useQuery({
    queryKey: ['plugins', 'status'],
    queryFn: async () => {
      const response = await api.get('/plugins/status');
      return response.data;
    }
  });
}

export function usePluginList() {
  return useQuery({
    queryKey: ['plugins', 'list'],
    queryFn: async () => {
      const response = await api.get('/plugins');
      return response.data;
    }
  });
}

export function useReloadPlugins() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async () => {
      // Get current plugin config and reload via reloadPlugins endpoint if exists
      const configResponse = await api.get('/config/plugins');
      const pluginConfig = configResponse.data;
      
      // Trigger reload by updating config (which will be picked up by agent on next restart)
      const response = await api.put('/config/plugins', pluginConfig);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['plugins'] });
      queryClient.invalidateQueries({ queryKey: ['plugins', 'status'] });
    }
  });
}